<template>
    <div class="home">
        <div class="notification is-warning" v-if="loading==true">Loading Sample Request ... </div>


        <div class="button is-fullwidth is-success mb-5" v-if="sample.submitted==0 && sample.items.length > 0 && this.loading==false" :disabled="working==true" @click="submitRequest()">SUBMIT REQUEST</div>
        <div class="button is-fullwidth is-danger mb-5" v-if="sample.submitted==1 && sample.returned == 1 && sample.items.length > 0 && this.loading==false" :disabled="working==true" @click="resubmitRequest()">RETURN REQUEST</div>
        
        <div class="box" v-if="loading==false">	
              
             <div class="tabs">
            <ul>
                <li ><a><strong>Request ID : {{ sample.id }}</strong></a></li>
                <li :class="{'is-active' : tabToView == 'details'}" @click="tabToView='details'"><a>Request Details</a></li>
                <li :class="{'is-active' : tabToView == 'attachments'}" @click="tabToView='attachments'"><a>Attachments</a></li>
                <li :class="{'is-active' : tabToView == 'items'}" @click="tabToView='items'"><a>Items/Garments <span v-if="sample != '' && sample.items.length>0">&nbsp;({{ sample.items.length }})</span></a></li>
                <li :class="{'is-active' : tabToView == 'notes'}" @click="tabToView='notes'"><a>Notes <span v-if="sample != '' &&  sample.notes.length>0">&nbsp;({{ sample.notes.length }})</span></a></li>
                <li :class="{'is-active' : tabToView == 'log'}" @click="tabToView='log'" style="display:none"><a>Log</a></li>
            </ul>
            </div>
            
            <div v-if="tabToView=='details'">
                
                <div class="field">
                          <label class="label">Requestor</label>
                          <div class="control">
                            <select class="input" v-model="sample.user_id"  required >
                                <option value="">Please select ...</option>
                               <option :value="row.userID" v-for="row in users" :key="row.userID">{{ row.firstname}} {{  row.surname }}</option>
                               
                            </select>
                          </div>
                      </div>

                      <div class="field" v-if="sample.team_id > 0">
                          <label class="label">Team/Club Name </label>
                          <div class="control">
                            <select class="input" v-model="sample.team_id"  required >
                                <option value="">Please select ...</option>
                                <option :value="row.id" v-for="row in teams" :key="row.id">{{ row.name}}</option>
                               
                            </select>
                             
                          </div>
                      </div>

                      <div class="field" v-if="sample.club_name != ''">
                          <label class="label">Other Team/Club Name </label>
                          <div class="control">
                            <input class="input" type="text" v-model="sample.club_name" >
                             
                          </div>
                      </div>

                      <div class="field ">
                          <label class="label">Sample Type</label>
                          <div class="control select is-fullwidth">
                              <select class="input" v-model="sample.sample_type_id"  required >
                                <option value="">Please select ...</option>
                                <option :value="row.id" v-for="row in sample_types" :key="row.id">{{ row.name}}</option>
                               
                            </select>
                          </div>
                      </div>
      
                      <div class="field">
                          <label class="label">Is This A Follow Up To A Previous Request ? </label>
                          <div class="control">
                              <input class="input" type="text" v-model="sample.follow_up" placeholder="Enter previous request ID here"  >
                             
                          </div>
                      </div>
                     
                      <div class="field">
                          <label class="label">Potential Order Quantity </label>
                          <div class="control">
                              <input class="input" type="number" v-model="sample.quantity" min="1" step="1" required @keypress="isNumber($event)">
                             
                          </div>
                      </div>

                      <div class="field">
                          <label class="label">Generic Request Instructions</label>
                          <div class="control">
                              <textarea class="textarea"  v-model="sample.instructions"  ></textarea>
                                <small>You can add instructions for each item in the Items tab</small>
                          </div>
                      </div>

                      <div v-if="sample.processed == 1">
                        <div class="columns">
                            <div class="column">

                                <div class="field">
                                <label class="label">Print Location</label>
                                <div class="control">
                                    <div class="select">
                                    <select>
                                        <option>Select dropdown</option>
                                        <option selected>Strabane</option>
                                    </select>
                                    </div>
                                </div>
                                </div>

                            </div>
                             <div class="column">

                                <div class="field">
                                <label class="label">Cutting Location</label>
                                <div class="control">
                                    <div class="select">
                                    <select>
                                        <option>Select dropdown</option>
                                        <option selected>Strabane</option>
                                    </select>
                                    </div>
                                </div>
                                </div>

                            </div>
                            <div class="column">

                                <div class="field">
                                <label class="label">Makeup Location</label>
                                <div class="control">
                                    <div class="select">
                                    <select>
                                        <option>Select dropdown</option>
                                        <option selected>Giurgiu</option>
                                    </select>
                                    </div>
                                </div>
                                </div>

                            </div>

                        </div>
                      </div>
                </div>
                <!-- End of details tab -->
                     
                     
            
            <div v-if="tabToView=='attachments'">
                <h2 class="title is-size-5">Generic Request Attachments</h2>
                <table class="table is-fullwidth is-striped">
                    <thead>
                        <tr>
                            <th>Filename</th>
                            <th>Description</th>
                            <th>Date Added</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row) in sample.attachments" :key="row.id">
                            <td><A :href="ASP_SYSTEM_URL + '/uploads/samples/' + row.sample_id + '/' + row.filename" target="_blank">{{ row.filename }}</A></td>
                            <td>{{  row.description }}</td>
                             <td>{{  row.date_added | formatUKDate}}</td>
                        </tr>
                        
                    </tbody>
                </table>
                <hr />


                <h2 class="title is-size-5">Upload New Attachment</h2>

                <form @submit.prevent="submitFile">
                    <div class="field">
                        <div class="control">
                            <input ref="fileInput" class="input" type="file" placeholder="select file ..." @change="handleFileUpload">
                        </div>
                        </div>
                        <div class="field  ">
                                        <label class="label">Description</label>
                                        <div class="control  is-fullwidth">
                                            <input type="text"  class="input" v-model="file_description"   />
                                            
                                        </div>
                                    </div>
                        <div class="field is-grouped">
                            <div class="control">
                                <button class="button is-link" type="submit" :disabled="this.working==true">Submit</button>
                            </div>
                        
                        </div>
                </form>
            </div>
            <!-- end of attachments panel-->
        

         <div v-if="tabToView=='items'">
            <button class="button is-small is-pulled-right is-success" @click="addItem()">Add new Item</button>
            <h2 class="title is-size-5">Request Items</h2>
            <table class="table is-fullwidth is-striped">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Garment</th>
                        <th>Fabric</th>
                        <th>Type</th>
                        <th>Qty</th>
                        <th>Extras</th>
                        
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row, index) in sample.items" :key="row.id">
                        <td>{{  index+1 }}</td>
                        <td>{{ row.garmentname }}</td>
                        <td>{{ row.fabric_name }}</td>
                        <td>{{ row.sample_item_type_name}}</td>
                        <td>{{ row.quantity}}</td>
                        <td >
                            <div class="tags">
                            <span class="tag " v-if="row.embroidery==1" :class="{'is-success' : row.embroidery_completed==1}">Embroidery</span>
                            <span class="tag " v-if="row.trims==1" :class="{'is-success' : row.trims_completed==1}">Trims</span>
                            <span class="tag " v-if="row.dtf==1" :class="{'is-success' : row.dtf_completed==1}">DTF</span>
                            <span class="tag " v-if="row.silicon==1" :class="{'is-success' : row.silicon_completed==1}">Silcon</span>
                            </div>
                        </td>
                       
                    </tr>
                    
                </tbody>
            </table>
         

                <div class="modal " v-bind:class="{ 'is-active' : showAddItemModal} ">
                    <div class="modal-background"></div>
                    <div class="modal-card process">
                        <header class="modal-card-head">
                        <p class="modal-card-title">Add New Item</p>
                        <button class="delete" aria-label="close" @click="showAddItemModal=false"></button>
                        </header>
                        <section class="modal-card-body">
                            <form @submit.prevent="saveSampleItem">
                            
                                    <div class="field ">
                                        <label class="label">Garment</label>
                                         <div class="dropdown-trigger">
                                                    <input
                                                    class="input"
                                                    type="text"
                                                    placeholder="Search garments..."
                                                    v-model="garmentQuery"
                                                    @focus="active = true"
                                                    >
                                                </div>
                                        <div class="control select is-fullwidth">
                                           
                                                        <select class="input" v-model="garment_id"  required >
                                                <option value="">Please select ...</option>
                                            <option  v-for="row in filteredGarments" v-bind:key="row.id" :value="row.garmentID">{{ row.garmentname }}</option>
                                        
                                            </select>

                                            
                                        </div>
                                    </div>
                                    <div class="field ">
                                        <label class="label">Fabric</label>
                                        <div class="control select is-fullwidth">
                                            <select class="input" v-model="fabric_id"   >
                                                <option value="">Please select ...</option>
                                            <option  v-for="row in fabrics" v-bind:key="row.id" :value="row.id">{{ row.name }}</option>
                                        
                                            </select>
                                        </div>
                                    </div>

                                
                                    <div class="field  ">
                                        <label class="label">Request Type</label>
                                        <div class="control select is-fullwidth">
                                            <select class="input" v-model="sample_item_type_id"  required >
                                                <option value="">Please select ...</option>
                                            <option :value="row.id" v-for="row in sample_item_types" :key="row.id">{{ row.name}}</option>
                                            
                                            </select>
                                        </div>
                                    </div>

                                    <div class="field  ">
                                        <label class="label">Number of Items</label>
                                        <div class="control  is-fullwidth">
                                            <input type="number" min="1" step="1" class="input" v-model="item_quantity"  required />
                                            
                                        </div>
                                    </div>
                    
                                    <div class="field  ">
                                        <label class="label">Extras</label>
                                        <div class="control tags ">
                                            <span class="button tag " :class="{'is-success' : item_embroidery == true}"  @click="item_embroidery = !item_embroidery">Emb.</span>
                                            <span class="button tag " :class="{'is-success' : item_trims == true}"  @click="item_trims = !item_trims">Trims</span>
                                            <span class="button tag " :class="{'is-success' : item_dtf == true}"  @click="item_dtf = !item_dtf">DTF</span>
                                            <span class="button tag " :class="{'is-success' : item_silicon == true}"  @click="item_silicon = !item_silicon">Silicon</span>
                                        </div>
                                    </div>
                                    
                                
                                    <div class="field">
                                        <label class="label">Item Instructions</label>
                                        <div class="control">
                                            <textarea class="textarea"  v-model="item_instructions" required ></textarea>
                                            
                                        </div>
                                    </div>

                                    <div class="field" style="display:none">
                                        <label class="label">Item Attachments</label>
                                        <div class="control">
                                            <p><em>Derry 2024 Crest Logo.jpg</em></p>
                                            <p><em>Embroidery Photo Logo.png</em></p>
                                                <input type="file" />
                                        </div>
                                    </div>

                                    
                    
                                    <div class="field is-grouped mt-5">
                                        <div class="control">
                                            <button type="submit" class="button is-success" :disabled="working==true" >Save Item</button>
                                        </div>
                                    </div>
                                </form>
                        </section>
                    </div>
                </div>
                <!-- end of add item modal-->

         </div>
          <!-- end of items pabel -->
        

          <div v-if="tabToView=='notes'">
            <button class="button is-small is-pulled-right is-success" @click="addNote()">Add a Note</button>	
            <h3 class="title is-size-5">Notes</h3>
            <table class="table is-striped is-fullwidth">
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>User</th>
                        <th>Note</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="row in sample.notes" :key="row.id">
                        <td>{{ row.date | formatUKDate }}</td>
                        <td>{{ row.user_firstname}} {{ row.user_surname}}</td>
                        <td>{{ row.note }}</td>
                    </tr>
                   

                </tbody>
            </table>
                <!-- Add Note model-->
                <div class="modal " v-bind:class="{ 'is-active' : showAddNoteModal} ">
                    <div class="modal-background"></div>
                    <div class="modal-card process">
                        <header class="modal-card-head">
                        <p class="modal-card-title">Add a Note</p>
                        <button class="delete" aria-label="close" @click="showAddNoteModal=false"></button>
                        </header>
                        <section class="modal-card-body">
                            <form @submit.prevent="saveSampleNote()">
                            
                                   
                                    <div class="field">
                                        <label class="label">Your Note</label>
                                        <div class="control">
                                            <textarea class="textarea"  v-model="note_text" required ></textarea>
                                        </div>
                                    </div>
                                    <div class="field" v-if="sample.returned==0 ">
                                        <label class="checkbox">
                                        <input type="checkbox" checked v-model="return_request" />
                                        Return sample to the requestor for more information
                                        </label>
                                        <br />
                                        <small>This should only be used for produciton, needs removed for requestors. Please untick</small>
                                    </div>

                                   
                                    <div class="field is-grouped mt-5">
                                        <div class="control">
                                            <button type="submit" class="button is-success" :disabled="working==true" >Save Note</button>
                                        </div>
                                    </div>
                                </form>
                        </section>
                    </div>
                </div>
                <!-- end of add note modal-->
          </div>
          <!-- end of notes tab-->
        </div>
        <!-- end of main box-->

          <div class="button is-fullwidth is-success mb-5" v-if="sample.submitted==0 && sample.items.length > 0 && this.loading==false" :disabled="working==true" @click="submitRequest()">SUBMIT REQUEST</div>
          <div class="button is-fullwidth is-danger mb-5" v-if="sample.submitted==1 && sample.returned == 1 && sample.items.length > 0 && this.loading==false" :disabled="working==true" @click="resubmitRequest()">RETURN REQUEST</div>
        
      </div>
  </template>

<script>
    import SampleService from '@/services/SampleService.js';
    import UtilityService from '@/services/UtilityService.js';

    export default {
      name: 'ViewSampleRequest',
      
        mixins: [],
        data: function () {
            return {
                   loading : false,
                  search: "",
                    API_NAME: process.env.VUE_APP_API_NAME,
                    ASP_SYSTEM_URL: process.env.VUE_APP_ASP_URL,
                    accessToken: '',
                    sample: [],
                    users: [],
                    sample_types: [],
                    sample_item_types: [],
                    showAddItemModal: false,
                    garments: [],
                    garment_id: '',
                    sample_item_type_id: '',
                    item_quantity: '',
                    item_instructions: '',
                    working:false,
                    item_silicon: false,
                    item_embroidery: false,
                    item_trims: false,
                    item_dtf: false,
                    file: null,
                    teams:[],
                    fabrics: [],
                    fabric_id: '',
                    tabToView:'details',
                    showAddNoteModal: false,
                    note_text: '',
                    garmentQuery: '',
                    include_hidden: 0,
                    return_request: true,
                    file_description: ''
                   
                   
            }
        },
        created() {
          this.getAccessToken()
            .then(() => { 
               this.getSample();
               this.getTeams();
               this.getUserMappings();
               this.getSampleTypes();
               this.getGarments();
                
               this.getSampleItemTypes();
            });
          
        },
        methods: {
            addItem() {
                this.showAddItemModal=true
              this.getFabrics();  
            },
            addNote() {
                this.note_text = ''
                this.showAddNoteModal=true
                
            },
            handleFileUpload(event) {
                this.file = event.target.files[0];
                },
                submitFile() {
                    if (!this.file) {
                        alert("Please select a file first.");
                        return;
                    }
                    this.working = true
        
                    var sample_id = this.$route.params.id;

                    let formData = new FormData();
                    formData.append("file", this.file);
                    formData.append("sample_id", sample_id);
                    formData.append("file_description", this.file_description);

                    SampleService.saveSampleAttachment(this.accessToken, formData)
                    .then(() => {
                        this.working = false
                        // Clear the file input field
                        this.$refs.fileInput.value = "";
                        this.file = null; // Reset file data
                        this.file_description = ''
                        //console.log(response)
                        this.getSample();
                    }).catch((error) => {
                    alert("Something went wrong and the order has not been updated. Please reload and try again")
                        console.log("Error:" + JSON.stringify(error.response.data));
                        this.working = false
                    });
                },
            async getGarments() {
                this.loading = true;
                UtilityService.getSimpleApiData(this.accessToken, "garments?order_by=garmentname ASC&include_hidden=" + this.include_hidden).then(
                    response => {
                        this.garments = response 
                        this.loading = false;
                    }
                    );
            },
            async getTeams() {
                UtilityService.getSimpleApiData(this.accessToken, "teams").then(
                response => this.teams = response 
                );
            },
            async getFabrics() {
                UtilityService.getSimpleApiData(this.accessToken, "fabrics").then(
                response => this.fabrics = response 
                );
            },
            async getUserMappings() {
                UtilityService.getSimpleApiData(this.accessToken, "user_mappings").then(
                    response => this.users = response 
                );
            },
            async getSampleTypes() {
                UtilityService.getSimpleApiData(this.accessToken, "sample_types").then(
                response => this.sample_types = response 
                );
            },
            async getSampleItemTypes() {
                UtilityService.getSimpleApiData(this.accessToken, "sample_item_types").then(
                response => this.sample_item_types = response 
                );
            },
            async getSample() {
                this.loading=true
                SampleService.getSample(this.accessToken, this.$route.params.id)
                .then(
                    (sample => {
                        this.$set(this, "sample", sample);
                        this.loading=false
                        this.working = false
                        this.showAddItemModal = false
                    }).bind(this)
                );
            },
            isNumber: function(evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) ) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            async saveSampleItem() {
                
                this.working = true
                var formdata = { 
                    sample_id : this.sample.id,
                    sample_item_type_id: this.sample_item_type_id,
                    garment_id: this.garment_id,
                    fabric_id: this.fabric_id,
                    item_quantity : this.item_quantity,
                    item_instructions : this.item_instructions,
                    item_embroidery : this.item_embroidery,
                    item_silicon : this.item_silicon,
                    item_trims : this.item_trims,
                    item_dtf : this.item_dtf,
                }; 

                SampleService.saveSampleItem(this.accessToken, formdata)
                .then((response) => {
                    this.getSample();
                    console.log(response)
                    
                    }).catch((error) => {
                        if(error.response.status === 422)
                        {
                            console.log("Error:" + JSON.stringify(error.response.data));
                        }
                        alert("Something went wrong. Make sure you have filled in all the fields. \nOr ring David !!")
                        this.working = false
                });
                
            },
            async saveSampleNote() {
                
                this.working = true
                var formdata = { 
                    sample_id : this.sample.id,
                    note_text: this.note_text,
                    return_request: this.return_request
                }; 

                SampleService.saveSampleNote(this.accessToken, formdata)
                .then((response) => {
                    this.getSample();
                    
                    this.showAddNoteModal = false
                    this.working=false

                    console.log(response)
                    
                    }).catch((error) => {
                        if(error.response.status === 422)
                        {
                            console.log("Error:" + JSON.stringify(error.response.data));
                        }
                        alert("Something went wrong. Make sure you have filled in all the fields. \nOr ring David !!")
                        this.working = false
                });
                
            },
            getStartDate() {
            
                var d = new Date();
                
                d.setDate(d.getDate() );
                return d.toISOString().slice(0,10);
                
            },
            async submitRequest(){
                this.working = true
                if(confirm('Are you sure you want to submit this request for production ?'))
                {
                    var sample_id = this.sample.id
                
                    SampleService.submitSample(this.accessToken, sample_id)
                    .then(() => {
                        this.working = false
                        //console.log(response)
                        this.$router.push("/samples/list-samples/mysamples");
                    }).catch((error) => {
                    alert("Something went wrong and the order has not been updated. Please reload and try again")
                        console.log("Error:" + JSON.stringify(error.response.data));
                        this.working = false
                    });
                }
                else {
                    this.working=false;
                    return false;
                }
              
            },
            async resubmitRequest(){
                this.working = true
                if(confirm('Are you sure you want to re-submit this request for production ?'))
                {
                    var sample_id = this.sample.id
                
                    SampleService.resubmitSample(this.accessToken, sample_id)
                    .then(() => {
                        this.working = false
                        //console.log(response)
                        this.$router.push("/samples/list-samples/mysamples");
                    }).catch((error) => {
                    alert("Something went wrong and the order has not been updated. Please reload and try again")
                        console.log("Error:" + JSON.stringify(error.response.data));
                        this.working = false
                    });
                }
                else {
                    this.working=false;
                    return false;
                }
              
            }
           
        },
        computed : {
            filteredGarments: function () {
            
                return this.garments.filter(garment =>
                    garment.garmentname.toLowerCase().includes(this.garmentQuery.toLowerCase())
                    );
            
            },
        }
       
    }
    </script>